const SvgFooterBackground = _props => null

export default SvgFooterBackground
